const noticeMngt = {
    namespaced: true,
    state : {
        boardNoticeId : '',
        title : '',
        noticeStatus : '',
        startDate : '',
        endDate : '',
        status : ''
    },
    getters: {
        getBoardNoticeId (state) {
            return state.boardNoticeId
        },
        getTitle (state) {
            return state.title
        },
        getNoticeStatus (state) {
            return state.noticeStatus
        },
        getStartDate (state) {
            return state.startDate
        },
        getEndDate (state) {
            return state.endDate
        },
        getStatus (state) {
            return state.status
        }

    },
    mutations: {
        setBoardNoticeId (state, payload) {
            state.boardNoticeId = payload
        },
        setTitle (state, payload) {
            state.title = payload
        },
        setNoticeStatus (state, payload) {
            state.noticeStatus = payload
        },
        setStartDate (state, payload) {
            state.startDate = payload
        },
        setEndDate (state, payload) {
            state.endDate = payload
        },
        setStatus (state, payload) {
            state.status = payload
        },


    },
    actions: {
        setBoardNoticeId ({commit}, payload) {
            commit('setBoardNoticeId', payload)
        },
        setTitle ({commit}, payload) {
            commit('setTitle', payload)
        },
        setNoticeStatus ({commit}, payload) {
            commit('setNoticeStatus', payload)
        },
        setStartDate ({commit}, payload) {
            commit('setStartDate', payload)
        },
        setEndDate ({commit}, payload) {
            commit('setEndDate', payload)
        },
        setStatus ({commit}, payload) {
            commit('setStatus', payload)
        },
        setMedicineMngtinit ({commit}) {
            commit('setBoardNoticeId','');
            commit('setTitle','');
            commit('setNoticeStatus','');
            commit('setStartDate','');
            commit('setEndDate','');
            commit('setStatus','');
        },
    }
}


export default noticeMngt